import { useContext } from 'react';
import { ListSidebarContext } from './const';
import { ListSidebarContextProps } from './types';

export function useListSidebarProvider() {
	const context = useContext(ListSidebarContext);

	if (typeof context === 'undefined') {
		throw new Error('Please, provide ListBreadcrumbProvider');
	}

	return context as ListSidebarContextProps;
}
